import { createContext, useState, useRef } from 'react';
import LoadingBackDrop from '../components/global/Loading/LoadingBackDrop';
import ConfirmModal, { IConfirmModalProps } from '../components/global/Modal/ConfirmModal';
import { Box, SxProps } from '@mui/material';
import delay from '../utilitie/delay';

export interface IScreenContext {
    setIsLoading: (state: boolean) => void;
    isLoading: boolean;
    confirmbox: (confirmModalProps: IConfirmModalProps) => void;
    slidePageStyle: SxProps;
    setSlidePage: (status: boolean, callback?: () => void) => void;
    topEleRef: React.MutableRefObject<HTMLDivElement | undefined>
};

type Props = {
    children: JSX.Element
};

export const screenContext = createContext<Partial<IScreenContext>>({});

const ScreenProvider = ({ children }: Props) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    // confirm modal
    const initialConfirmModalProps: IConfirmModalProps & { open: boolean } = {
        open: false,
        onClose: () => { },
        onConfirm: () => { },
        callback: () => { }, // callback active when modal close
        detail: "",
        render: <></>,
    };

    const [confirmModalProps, setConfirmModalProps] = useState<IConfirmModalProps & { open: boolean }>(initialConfirmModalProps);

    const confirmbox = (confirmModalProps: IConfirmModalProps) => {
        setConfirmModalProps({
            open: true,
            ...confirmModalProps,
            onClose: () => {
                if (confirmModalProps.onClose) confirmModalProps.onClose()
                setConfirmModalProps({ ...initialConfirmModalProps })
            },
        })
    };



    // slidpage styles
    const initialSlidPageStyle = {
        main: {
            transition: '.4s',
            transform: 'translateX(0)',
        },
        provide: {
            transition: '.4s',
            transform: 'translateX(100%)',
        }
    }
    const [slidePageStyle, setSlidePageStyle] = useState<{ main: SxProps, provide: SxProps }>(initialSlidPageStyle);

    const setSlidePage = (status: boolean, callback?: () => void) => {
        if (status) {
            setSlidePageStyle(prev => ({
                main: {
                    ...prev.main,
                    transform: 'translateX(-60%)',
                },
                provide: {
                    ...prev.provide,
                    transform: 'translateX(60%)',
                    boxShadow: '-200px 0px 200px 200px #0000004d',
                }
            }))
        } else setSlidePageStyle(initialSlidPageStyle)

        if (callback) delay(400, callback)
    };

    const topEleRef = useRef<HTMLDivElement>()

    return (
        <>
            <screenContext.Provider value={{ isLoading, setIsLoading, confirmbox, slidePageStyle: slidePageStyle.provide, setSlidePage, topEleRef }}>
                <Box sx={slidePageStyle.main} id='custom-style' ref={topEleRef}>
                    {children}
                    {confirmModalProps.open && <ConfirmModal {...confirmModalProps} />}
                    {isLoading && <LoadingBackDrop />}
                </Box>
            </screenContext.Provider>
        </>
    );
};

export default ScreenProvider;